export default {
  'accessLog.title': 'Manage Access Logs',
  'accessLog.operationType.login': 'Login',
  'accessLog.operationType.logout': 'Logout',
  'accessLog.operationType.refreshCredentials': 'Refresh credentials',
  'accessLog.form.operationType': 'Operation Type',
  'accessLog.accessType.mixed': 'Mixed',
  'accessLog.accessType.userAndPassword': 'Username and Password',
  'accessLog.accessType.office365': 'Office365',
  'accessLog.accessType.google': 'Google',
  'accessLog.accessType.automy': 'AUTOMY',
  'accessLog.text.accessType': 'Access Type',
  'accessLog.text.isSuccessfulOperation': 'Successful Operation?',
  'accessLog.text.ip': 'IP',
  'accessLog.text.appClient': 'Application',
  'accessLog.text.observations': 'Observations',
  'accessLog.text.country': 'Country',
  'accessLog.text.city': 'City',
  'accessLog.text.state': 'State',
  'accessLog.text.userAgent': 'User Agent',
};
